<template>
  <div>
    <!-- page wrapper start -->
    <div class="pg-wrapper store-profile" v-if="locationNotFound">
      <app-header :class="'fixed'"></app-header>
      <main class="content-wrapper has-background-lightgrey min-80vh mt-50 location-not-found">
        <h2>Location not found!</h2>
      </main>
    </div>

    <div class="pg-wrapper store-profile store-landing" v-else>
      <app-header :class="'fixed'"></app-header>
      <main class="content-wrapper has-background-lightgrey min-80vh" v-if="!loadedDetail || !loadedFeaturedData">
        <store-landing-skeleton/>
      </main>

      <main
        :class="'content-wrapper has-background-lightgrey '+ (vg_orderNotification.show ? 'has-notification' : '')"
        v-else
      >

        <!-- Section banner -->
        <section
          v-if="!kioskMode && locationPromotionImages && locationPromotionImages.length > 0"
          id="store-profile-banner"
          class="pb20"
        >
          <div class="container xl">
            <VueSlickCarousel 
              :arrows="true" 
              :dots="true" 
              :infinite="true" 
              :slidesToShow="1" 
              :draggable="false" 
              :pauseOnHover="false" 
              :autoplaySpeed="4000" 
              :speed="1000" 
              :autoplay="true"
            >
              <a :href="generateValidUrl(slide.ctaValue)" v-for="(slide, index) in locationPromotionImages" :key="'slider_'+index">
                <img :src="slide.imgUrl" :alt="locationDetail.ctaText"/>
              </a>
              <template #prevArrow="">
                <div class="budler-custom-arrow">
                  <img src="@/assets/img/icon-nav-arrow-left.svg" alt="prev" />
                </div>
              </template>
              <template #nextArrow="">
                <div class="budler-custom-arrow">
                <img src="@/assets/img/icon-nav-arrow-right.svg" alt="next" />
                </div>
              </template>
            </VueSlickCarousel>
          </div>
        </section>

        <!-- Section: Selected Store Info -->

        <section class="selected-store-info is-hidden-tablet" v-if="show_banner">
          <div class="container xl">
            <div class="columns mb0 is-mobile selected-store-info--header">
              <!-- Address: selected store -->
              <div class="column is-12-mobile is-12-tablet store-info mb5 mt5">
                <div class="store-detail" id="store_detail">
                  <h2 class="store-name">{{ locationDetail.display_name }}</h2>
                  <div class="store-wrapper">
                    <span @click.prevent="getDirection(locationDetail)" 
                      class="store-address is-underlined cursor-pointer hover-opacity-6 text-blue"
                    >{{ locationDetail.address ? locationDetail.address.formatted_address : ''}}</span>
                  </div>
                  <p
                    class=""
                  >{{locationDetail.contact_details && locationDetail.contact_details.length > 0 ? getContactValue(locationDetail.contact_details, 'phone', 'display_value') : '' }}</p>
                </div>
                <div
                  :class="locationDetail.address ? ' wrapper-store-map-timing hide-map' : ' wrapper-store-map-timing hide-map'"
                > 
                  <div class="dropdown dropdown-open-close">
                    <div class="dropdown-trigger">
                      <button
                        class="button"
                        onclick="javascript:document.querySelector('.dropdown-open-close').classList.toggle('is-active')"
                        onblur="javascript:document.querySelector('.dropdown-open-close').classList.remove('is-active')"
                        aria-haspopup="true"
                        aria-controls="dropdown-menu"
                      >
                        <span
                          :class="'availability-status' + (locationDetail.currently_open ? ' has-text-green' : ' has-text-red')"
                        >&nbsp; {{ locationDetail.currently_open ? 'Open now' : 'Closed now'}}</span>

                        <span
                          class="drop-down-spacer has-text-black"
                        >{{ locationDetail.currently_open ? getTodaysOpenCloseSchedule() : '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' }}</span>
                      </button>
                    </div>
                    <div class="dropdown-menu" id="dropdown-menu">
                      <div class="ddown-content">
                        <template v-for="(item, ind) in locationDetail.hours_of_operation">
                          <a
                            :class="'dropdown-item ' + (item.day == todayDayNumber() ? 'active':'')"
                            :key="ind"
                          >
                            <span
                              class="day has-text-black"
                            >{{item.day_name}} {{ item.day == todayDayNumber() ? '(today)':''}}</span>
                            <span v-if="!item.is_open" class="timing has-text-black">Closed</span>
                            <span v-else class="timing has-text-black">{{getOpenCloseTime(item)}}</span>
                          </a>
                        </template>
                      </div>
                    </div>
                    
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </section>

        <loading v-if="loadedFeaturedData == false"/>
        <template v-else>

          <section class="store-landing-featured-wrapper">
            <div class="container xl">
              <div class="featured-shop-cats-heading">
                <h2 class="is-size-4 mb-3">Categories 
                  <router-link class="shop-link no-underline has-text-weight-medium text-primary hover-text-primary hover-opacity-7 is-size-14" :to="{ 
                    name: 'StoreProfile', 
                    params: { business_slug: $route.params.business_slug, store_slug: $route.params.store_slug },
                    query: $route.query
                  }">VIEW MENU 
                    <svg width="9px" height="12px" viewBox="0 0 9 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g id="-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g id="Desktop---Homepage---Desktop-HD" transform="translate(-1226.000000, -808.000000)" fill="#302F30">
                              <g id="Group-6-Copy" transform="translate(1215.000000, 800.000000)">
                                  <g id="Icon/Arrow/Line/Left" transform="translate(15.000000, 14.750000) scale(-1, 1) translate(-15.000000, -14.750000) translate(10.000000, 8.000000)">
                                      <g id="Arrow" transform="translate(4.537500, 7.012500) scale(-1, 1) rotate(-90.000000) translate(-4.537500, -7.012500) translate(-2.062500, 2.887500)">
                                          <path d="M10.519789,-2.19557262 C10.2187806,-2.53690706 9.69818904,-2.57012988 9.3562172,-2.26982878 L2.75439107,3.50565068 C2.57676033,3.66227594 2.475,3.88765691 2.475,4.12445205 C2.475,4.36124719 2.57676033,4.58662816 2.75439107,4.74325342 L9.3562172,10.5187329 C9.5066598,10.6513855 9.70027764,10.7247114 9.90086785,10.725 C10.1378958,10.7246999 10.3633507,10.6225135 10.519789,10.4444767 C10.8201483,10.1025711 10.7869191,9.58208031 10.4455185,9.28113014 L4.55338869,4.12445205 L10.4455185,-1.03222604 C10.7869191,-1.33317621 10.8201483,-1.85366698 10.519789,-2.19557262 Z" id="Path" transform="translate(6.600000, 4.125000) scale(-1, 1) rotate(-90.000000) translate(-6.600000, -4.125000) "></path>
                                      </g>
                                  </g>
                              </g>
                          </g>
                      </g>
                    </svg>
                  </router-link>
                </h2> 
              </div>
              <div :class="'store-landing-shop-categories item-on-row-' +slidePerView ">
                <swiper
                  ref="swiper"
                  :slides-per-view="slidePerView"
                  :scrollbar="{ draggable: true }"
                  :loop="false"
                  :navigation="nav"
                  :initialSlide="1"
                  :slidesPerGroup="2"
                  :freeMode="true"
                  :spaceBetween="10"
                  :breakpoints="breakpoints"
                  :observer="true"
                  :observeParents="true"
                >
                  <swiper-slide
                    v-for="(category, index) in storeProfileCategories" 
                    :class="category.active ? 'category-item p0 is-active' : 'category-item p0'"
                    :key="index"
                  >
                    <a href="#" @click.prevent='goToCatPage(category.name)'  class="has-text-weight-semibold is-size-6">
                        <span>{{ category.name }}</span>
                    </a>
                  </swiper-slide>
                </swiper>
                <div class="budler-custom-arrow arrow-prev" @click="prev">
                  <svg width="11px" height="17px" viewBox="0 0 11 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g id="-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g id="cat_items_arrrow_left" transform="translate(-17.000000, -113.000000)" fill="#302F30">
                              <g id="Icon/Arrow/Line/Left" transform="translate(17.000000, 113.000000)">
                                  <g id="Arrow" transform="translate(5.500000, 8.500000) scale(-1, 1) rotate(-90.000000) translate(-5.500000, -8.500000) translate(-2.500000, 3.500000)">
                                      <path d="M12.7512595,-2.66130014 C12.3864007,-3.07503886 11.7553807,-3.11530894 11.3408693,-2.75130761 L3.33865585,4.24927355 C3.12334585,4.43912235 3,4.71231141 3,4.99933582 C3,5.28636023 3.12334585,5.55954928 3.33865585,5.74939808 L11.3408693,12.7499792 C11.523224,12.9107703 11.7579123,12.9996502 12.0010519,13 C12.2883586,12.9996363 12.5616372,12.8757739 12.7512595,12.6599718 C13.1153313,12.2455407 13.0750534,11.6146428 12.6612346,11.2498547 L5.51925902,4.99933582 L12.6612346,-1.25118308 C13.0750534,-1.61597117 13.1153313,-2.24686907 12.7512595,-2.66130014 Z" id="Path" transform="translate(8.000000, 5.000000) scale(-1, 1) rotate(-90.000000) translate(-8.000000, -5.000000) "></path>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </svg>
                </div>
                <div class="budler-custom-arrow arrow-next" @click="next">
                  <svg width="9px" height="14px" viewBox="0 0 9 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="cat_items_arrrow_right" transform="translate(-1226.000000, -808.000000)" fill="#302F30">
                            <g id="Group-6-Copy" transform="translate(1215.000000, 800.000000)">
                                <g id="Icon/Arrow/Line/Left" transform="translate(15.000000, 14.750000) scale(-1, 1) translate(-15.000000, -14.750000) translate(10.000000, 8.000000)">
                                    <g id="Arrow" transform="translate(4.537500, 7.012500) scale(-1, 1) rotate(-90.000000) translate(-4.537500, -7.012500) translate(-2.062500, 2.887500)">
                                        <path d="M10.519789,-2.19557262 C10.2187806,-2.53690706 9.69818904,-2.57012988 9.3562172,-2.26982878 L2.75439107,3.50565068 C2.57676033,3.66227594 2.475,3.88765691 2.475,4.12445205 C2.475,4.36124719 2.57676033,4.58662816 2.75439107,4.74325342 L9.3562172,10.5187329 C9.5066598,10.6513855 9.70027764,10.7247114 9.90086785,10.725 C10.1378958,10.7246999 10.3633507,10.6225135 10.519789,10.4444767 C10.8201483,10.1025711 10.7869191,9.58208031 10.4455185,9.28113014 L4.55338869,4.12445205 L10.4455185,-1.03222604 C10.7869191,-1.33317621 10.8201483,-1.85366698 10.519789,-2.19557262 Z" id="Path" transform="translate(6.600000, 4.125000) scale(-1, 1) rotate(-90.000000) translate(-6.600000, -4.125000) "></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </section>

          <category-slider :callback="goToLocationProductDetail" v-if="featuredProducts.length > 0" :title="'Features'" :id="'featured'" :products="featuredProducts" />

          <template v-for="(category,index) in locationFeaturedCategories">
            <category-slider :callback="goToLocationProductDetail" v-bind:key="'landing-cat' + index"  v-if="collectAllProducts(category).length > 0" :title="category.name" :id="(category.id).toString()" :products="collectAllProducts(category)" />
          </template>
          <p v-if="featuredProducts.length == 0 && locationFeaturedCategories.length == 0" class="text-center pt-80">Sorry no category or product found.</p>
   
        </template>
      
      </main>
      <!-- <add-to-cart-modal :callback="goToLocationProductDetail"/> -->
      <app-footer />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';
import moment from 'moment';
import Env from '@/env';
import LocationApis from '@/Components/Controllers/LocationApis';
import UserApis from '@/Components/Controllers/UserApis';
import CartApis from '@/Components/Controllers/CartApis';
import PromotionApis from '@/Components/Controllers/PromotionApis';
import BusinerssProfileApis from '@/Components/Controllers/BusinerssProfileApis';
import CategorySlider from '@/Components/Pages/PageComponents/StoreLanding/CategorySlider';
import AddToCartModal from '@/Components/Pages/PageComponents/StoreLanding/AddToCartModal';
import StoreLandingSkeleton from '@/Components/Pages/PageComponents/StoreLanding/Skeleton';
import VueSlickCarousel from 'vue-slick-carousel';
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
SwiperCore.use([Navigation, Pagination])

export default {
  components: {
    StoreLandingSkeleton,
    CategorySlider,
    AddToCartModal,
    VueSlickCarousel,
    Swiper,
    SwiperSlide,
  },
  name: "StoreLanding",
  metaInfo() {
    return { 
      title: `${this.vg_businessProfile && this.vg_businessProfile.name ? this.vg_businessProfile.name : ''} Cannabis Store in ${this.vg_selectedStore.address && this.vg_selectedStore.address.city ? this.vg_selectedStore.address.city : 'Canada'}`,
      meta: [
        { name: 'description', content:  `${this.vg_businessProfile && this.vg_businessProfile.name ? this.vg_businessProfile.name : ''} Cannabis Store in ${this.vg_selectedStore.address && this.vg_selectedStore.address.city ? this.vg_selectedStore.address.city : 'Canada'}`,},
        { property: 'og:title', content: `${this.vg_businessProfile && this.vg_businessProfile.name ? this.vg_businessProfile.name : ''} Cannabis Store in ${this.vg_selectedStore.address && this.vg_selectedStore.address.city ? this.vg_selectedStore.address.city : 'Canada'}`,},
      ]
    }
  },
  data() {
    return {
      breakpoints: { 
        3000: {
          slidesPerView: 9,
        }, 
        1920: {
          slidesPerView: 9,
        }, 
        1400: {
          slidesPerView: 7,
        }, 
        1024: {
          slidesPerView: 5,
        }, 
        991: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 2,
        },
        320: {
          slidesPerView: 2,
        }
      },
      nav: {
         nextEl: ".arrow-next",
         prevEl: ".arrow-prev",
      },
      locationPromotionImages: [],
      storeProfileCategories: [],
      locationNotFound: false,
      show_map: true,
      show_banner: true,
      loadedDetail: false,
      storeFeaturedImage: '',
      hideAt: 0,
      hideBanner: false,
      locationDetail: {},
      loadedLocationDetail: false,
      dayName: {
        0: 'Sunday',
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday',
      },
      todayOpening: "",
      showStoreHours: false,
      store_slug: "",
      favLocationList: [],
      favLocationObj: {},
      isFavLocation: false,
      // Carousle datas
      featuredProducts: [],
      locationFeaturedCategories: [],
      loadedFeaturedData: false,
      locationAllCategoriesObj: {},
      isScreenMobile: false,
      swiping: false,
      slidestoScroll: 2,
      slidePerView:  9,

    };
  },
  
  computed: {
    ...mapGetters({
      vg_selectedStore: "location/selected",
      vg_orderNotification: "orderhistory/orderNotification",
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_businessProfile: "businessprofile/detail",
      vg_userId: "getLoggedInUserId",     
    }),

    /**
     * Slider per view
     */
    slidePerViewsss() {
      if(window.innerWidth <= 768) {
        return 2;
      } else if(window.innerWidth <= 991) {
        return 4;
      } else {
        return 9;
      }
    },

    kioskMode() {
       return (this.$route.query['kiosk'] && ( (this.$route.query['kiosk'] == 1) || (this.$route.query['kiosk'] == 'true') ) ) ? true : false;
    },
    
    userLoggedIn() {
      if (this.$store.getters.getLoggedInUserId != '') {
        return true;
      }
      return false;
    },

  },

  watch: {
    'swiping'(val) {
      // if(val){
      //   this.slidestoScroll = 1;
      // } else {
      //   this.slidestoScroll = 2;
      // }
      
    },
    'favLocationList'(favList) {
      let hasIdOnfav = _.find(favList, { id: this.locationDetail.id });
      if (hasIdOnfav == undefined) {
        this.isFavLocation = false;
      } else {
        this.isFavLocation = true;
      }
    },

    'userLoggedIn'(val) {
      if (val) {
        this.fetchLocationFav();
      }
    },

    'vg_userId'(val){
      if(val){
        Helpers.setPubNubUserLocationSubscribe({ 
          user_id: val, 
          location_id: this.locationDetail.id
        });
      }
    }
  },

  created() {
    // Set the location to blank so that on header it do not show old location, on mount we are refetching and setting selected location
    // if(this.vg_selectedStore.id) {
    //   this.va_setPastSelectedLocationId(this.vg_selectedStore.id);
    // }
    // this.va_setSelectedLocation({});
    
  },
  
  async mounted() {

    const self = this;
    this.loadedDetail = false;

    // let businessRes = await BusinerssProfileApis.fetchBusinessProfile(this.$route.params.business_slug);
    // if(businessRes.status != 200){
    //   // Its invalid business redirect to valid one
    //   this.va_snackbar({
    //     type: "warning",
    //     message: "Cannot find business."
    //   });
    //   return this.$router.push({ 
    //     name: 'HomePage', 
    //     params: {
    //       business_slug: Env.defaultBusinessSlug 
    //     },
    //     query: this.$route.query,
    //   });
    // }
  
    // let res = await LocationApis.fetchBySlug(this.$route.params.store_slug);
    // if (res.status != 200) {
    //   this.locationNotFound = true;
    //   this.va_snackbar({
    //     type: "warning",
    //     message: "Cannot find the store."
    //   });
    //   return false;
    // }

    let location_id = this.vg_selectedStore.id;
    if (!location_id) {
      this.locationNotFound = true;
      this.va_snackbar({
        type: "warning",
        message: "Cannot find the store."
      });
      return false;
    }

    let locationAllCategories = LocationApis.fetchAllLocationCategories(location_id)
    let locationPromotionRes = PromotionApis.locationPromotion(location_id);
    await Promise.all([locationAllCategories, locationPromotionRes]).then( async (promRes) => {
      if(promRes[0].status == 200){
        this.locationAllCategoriesObj = await Helpers.collectAllCategoriesInObj(promRes[0].data.payload);
      }
        if(promRes[1].status == 200){
          promRes[1].data.payload.forEach(item => {
            if(item.promotion){
              self.locationPromotionImages.push({
                name: item.promotion.name,
                imgUrl: item.promotion.image,
                ctaText: item.promotion.ctaText, 
                ctaType: item.promotion.ctaType,
                ctaValue: item.promotion.ctaValue,
              })
            }
          })
        }
    });

    this.loadedDetail = true;
  
    // Set Location data
    this.locationDetail = this.vg_selectedStore;
    this.loadedLocationDetail = true;

    // if user is guest only 
    if (this.vg_guestLandedQueries['guest-only'] || (this.vg_guestLandedQueries['guest-only'] == 'true') || this.$route.query['guest-only'] ) {
      // then check on kiosk_settings
      this.show_banner = this.locationDetail.settings.kiosk_settings && this.locationDetail.settings.kiosk_settings.is_enabled ? this.locationDetail.settings.kiosk_settings.show_banner : true
      this.show_map = this.locationDetail.settings.kiosk_settings  && this.locationDetail.settings.kiosk_settings.is_enabled? this.locationDetail.settings.kiosk_settings.show_map : true;
      // next is note down guest landed time 
      this.va_setGuestLandedTime(moment().format())
    }
    
    // if (this.vg_guestLandedQueries['hide-map']) {
    //   this.show_map = false
    // }
    // fetch fav location products
    let featuredProductsPromise = LocationApis.featuredProducts(this.locationDetail.id);
    let featuredCategoryPromise = LocationApis.featuredCategoryWithProducts(this.locationDetail.id);
    let hasAtleastAProduct = false;

    let params = Helpers.generateUrlParameter(this.vg_filters);
    let categoryWithProductsPromise = LocationApis.locationCategoriesOnly(this.locationDetail.id);

   // CartApis.locationCart(this.locationDetail.id, Helpers.getLocationCartFullUrl(this));
    
    await Promise.all([featuredProductsPromise, featuredCategoryPromise, categoryWithProductsPromise]).then(async  (res) => {
      if(res[0].status == 200){

        // filter whether produt
        this.featuredProducts = this.filterFeaturedProductDisplay(res[0].data.payload);
        if(this.featuredProducts.length > 0){
          hasAtleastAProduct = true;
        }
      }

      // Validate and pass featured category
      if(res[1].status == 200) {
        // Will filter on merge step
        this.locationFeaturedCategories = res[1].data.payload;
        // Check at least a category has featured product
        if(this.locationFeaturedCategories.length > 0){
          this.locationFeaturedCategories.map(item => {

            // check  every item going through validation
            if(item.featuredcategoriesproducts && (item.featuredcategoriesproducts.length > 0) ){
              for(let i = 0; i < item.featuredcategoriesproducts.length; i++) {
                let product = item.featuredcategoriesproducts[i];
                if (product.discontinued == false &&  (product.variants.length > 0) && (Helpers.isAllVariantOutOfStock(product.variants) == false)) {
                  hasAtleastAProduct = true;  
                  break;
                }
              }
            }
              
          })
        } 
      }

      

      if(res[2].status == 200) {
        // Show those category which has product
        this.storeProfileCategories = []; 
        let mainResult = res[2].data.payload;
        mainResult = _.orderBy(mainResult, ['sort_order', 'id'], ['asc', 'asc']);
        mainResult.forEach(item => {
          if(item.parent_category == null){
            // Now product must be available
            if ( item.products && (item.products.length > 0) ) {
              let data = [];
              // there must be a product
              data = item.products.filter(innerItem => {
                // remove discontinued , 0 varaints 
                if ( (innerItem.discontinued == false) && (innerItem.variants && innerItem.variants.length > 0) && (Helpers.isAllVariantOutOfStock(innerItem.variants) == false) ) { //  && Helpers.isAllVariantOutOfStock(innerItem.variants) == false
                  return innerItem;
                }
              })
              if (data.length > 0) { // if there is product after filter pass then add
                this.storeProfileCategories.push(item)
              }
            }
          }
        })
      }

      this.loadedFeaturedData = true;
    })

    // If no any product
    if(hasAtleastAProduct == false){
      // Redirect to store detail page
      return this.$router.push({ 
        name: 'StoreProfile', 
        params: {
          business_slug: this.$route.params.business_slug,
          store_slug: this.$route.params.store_slug,
        },
        query: this.$route.query,
      });
    }

   // Fetch location required data
    self.fetchLocationFav();

    // If user is logged in then to set status active
    if(this.userLoggedIn){
      setTimeout(()=> {
        UserApis.addUserLocation(this.$store.getters.getLoggedInUserId, location_id, this.$route.query);
        Helpers.pubnubSubscribeAllChannels({ 
          user_id: this.$store.getters.getLoggedInUserId, 
          location_id: this.locationDetail.id
        });
        Helpers.emitUserActivity();
      }, 1000)
    }

    this.onresize();
    window.addEventListener("resize", this.onresize);

  },

  destroyed() {
   window.removeEventListener("resize", this.onresize);
  },

  methods: {
    // <nav link refreshing page so lets use push
    goToCatPage(catName) {
      this.$router.push({
        name: 'StoreProfile', 
        params: { business_slug: this.$route.params.business_slug, store_slug: this.$route.params.store_slug }, 
        query: {...this.$route.query, ...{ category: catName} }
      })
    },
    prev() {
      if(this.$refs.swiper.$swiper){
        this.$refs.swiper.$swiper.slidePrev()
      }
    },

    next() {
      if(this.$refs.swiper.$swiper){
        this.$refs.swiper.$swiper.slideNext()
      }
    },
    setCarouselSwiping(state){
      this.swiping = state;
    },
    onresize() {
      if(window.innerWidth <= 768) {
        this.slidePerView = 2;
      } else if(window.innerWidth <= 991) {
        this.slidePerView = 4;
      } else {
        this.slidePerView = 9;
      }
      
      // if(window.innerWidth > 768) {
      //   this.isScreenMobile = false;
      // } else {
      //   this.isScreenMobile = true;
      // }
    },
  
    /**
     * Fetch fav location 
     */
    async fetchLocationFav() {
      if (this.$store.getters.getLoggedInUserId) {
        UserApis.fetchFavProducts();
        this.favLocationList = await UserApis.fetchFavLocations();
        let hasIdOnfav = _.find(this.favLocationList, { id: this.locationDetail.id });
        if (hasIdOnfav == undefined) {
          this.isFavLocation = false;
        } else {
          this.isFavLocation = true;
        }
      } else {
        this.favLocationList = [];
      }
    },

    /**
     * Fav location
     */
    async favouriteLocation() {
      if (!this.$store.getters.getLoggedInUserId) {
        this.va_snackbar({
          message: "Please login to proceed.",
          type: "warning",
        })
        return;
      }
      this.va_spinner(true);
      let res = await UserApis.addUserFavLocation(this.locationDetail.id);
      if (res.status == 201) {
        // success
        let reFetchIds = await UserApis.fetchFavLocations();
        this.favLocationList = reFetchIds;
      }
      this.va_spinner(false);
      this.va_snackbar({
        message: res.status == 201 ? res.data.msg : res.response.data ? res.response.data.msg : "Location favourite failed.",
        type: res.status == 201 ? "success" : "warning",
      })
    },

    /**
     * Unfav location
     */
    async unFavouriteLocation() {
      if (!this.$store.getters.getLoggedInUserId) {
        this.va_snackbar({
          message: "Please login to proceed.",
          type: "warning",
        })
        return;
      }
      this.va_spinner(true);
      let res = await UserApis.userUnFavLocation(this.locationDetail.id);
      if (res.status == 200) {
        // success
        let reFetchIds = await UserApis.fetchFavLocations();
        this.favLocationList = reFetchIds;
      }
      this.va_spinner(false);
      this.va_snackbar({
        message: res.status == 200 ? res.data.msg : res.response.data ? res.response.data.msg : "Location favourite failed.",
        type: res.status == 200 ? "success" : "warning",
      })
    },

    // handleScroll() {
    //   let w = window.innerWidth
    //     || document.documentElement.clientWidth
    //     || document.body.clientWidth;
        
    //   // hide only if product is more than 6
    //   if (window.scrollY > this.hideAt) {
    //     this.hideBanner = true;
    //     // if(w > 991){
    //     if (this.searchbar) {
    //       document.getElementById("search_text_top").focus();
    //     }
    //   } else if (window.scrollY < this.hideAt) {
    //     this.hideBanner = false;
    //     if (this.searchbar) {
    //       document.getElementById("search_text_bottom").focus();
    //     }
    //   }
    // },


    /**
     * Get contact value from object
     */
    getContactValue(arr, type, field) {
      let obj = _.find(arr, { 'type': type });
      if (obj != undefined) {
        return obj[field];
      }
      return '';
    },

    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'HomePage', query: this.$route.query, });
    },

    // Get opening and closing time for all the days of week
    getOpenCloseTime(item) {
      return `${moment(item.open_time, "HH:mm:ss").format("hh:mm a")} - ${moment(item.close_time, "HH:mm:ss").format("hh:mm a")}`;
    },

    todayDayNumber() {
      return new Date().getDay();
    },

    getTodaysOpenCloseSchedule() {
      let todaysSchedule = _.find(this.locationDetail.hours_of_operation, function (o) { return o.day == new Date().getDay(); });
      if (todaysSchedule != undefined) {
        return this.getOpenCloseTime(todaysSchedule);
      }
      return '';
    },
    
    /**
     * Merge featured products + products , update 2 not needed to merge
     */
    collectAllProducts(category){
      if(category.featuredcategoriesproducts && category.featuredcategoriesproducts.length > 0){

        return this.filterProductDisplay(category);
        //return this.filterProductDisplay(category.featuredcategoriesproducts.concat(category.products))
      }
      return [];
      //return this.filterProductDisplay(category.products);
    },

    /**
     * Filter featured category product
     */
    filterProductDisplay(category) {
      let products = category.featuredcategoriesproducts;
      let data = [];
      if (products.length > 0) {
        data = products.filter(item => {
          // remove discontinued , 0 varaints or all varinats not available
          if (item.discontinued == false &&  (item.variants.length > 0) && (Helpers.isAllVariantOutOfStock(item.variants) == false)) { // && Helpers.isAllVariantOutOfStock(item.variants) == false
            // add to the category product
            if(this.locationAllCategoriesObj.hasOwnProperty(item.category_id) ){
               item.category = this.locationAllCategoriesObj[item.category_id]
            } else {
              // Just to prevent crash in case no cat found
              item.category = {
                thc_cbd_value_type: 'range'
              };
            }
            return item;
          }
        })
      }
      return data;
    },

    /**
     * Display featured products product
     */
    filterFeaturedProductDisplay(products) {
      let data = [];
      if (products.length > 0) {
        data = products.filter(item => {
          // remove discontinued , 0 varaints or all varinats not available
          if (item.discontinued == false && item.variants.length > 0 && (Helpers.isAllVariantOutOfStock(item.variants) == false ) ) { // && Helpers.isAllVariantOutOfStock(item.variants) == false
            return item;
          }
        })
      }
      return data;
    },

    /**
     * Generate valid url
     */
    generateValidUrl(str) {
      if(str == ''){
        return '#';
      }
      let regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
      if(!regex.test(str)) {
      return 'https://'+str;
      } else {
        return str;
      }
    },

    /**
     * Go to locaiton product detail
     */
  
    goToLocationProductDetail(item) {
      this.$router.push({ 
        name: 'LocationProductDetail', 
        params: { store_slug: this.$route.params.store_slug, product_id: item.id },
        query: this.refineQuery(this.$route.query)
      })
    },

     /**
     * refine unnecessary query
     */
    refineQuery(query) {
      let removeObj = ['category', 'verify_email', 'token'];
      removeObj.forEach( (item) => {
        if(query.hasOwnProperty(item)){
          delete query[item];
        } 
      })
      return query;
    },

    /**
     * 
     * Open in new tab, location google map
     */
     getDirection(storeDetail) {
      // Open external google map
      if(!_.isEmpty(storeDetail) && !storeDetail.address) {
        return '';
      } else {
        window.open(`https://www.google.com/maps/place/${storeDetail.address.formatted_address}/@${storeDetail.address.latitude},${storeDetail.address.longitude},17.55z'`, '_blank');
      }
    },
  
    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setSelectedLocation: "location/setSelected",
      va_setGuestLandedTime: "location/setGuestLandedTime",
      va_setPastSelectedLocationId: "location/setPastSelectedLocationId",
    })
  }
};
</script>
<style >
.slick-slider.--swiping 
    .slick-list:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
    
}
</style>

